import React from 'react';

// Der Kalkulator ist eine eigenständige HTML-Seite in public/gefaesskalkulator/.
// Sie wird hier eingebettet, damit sie hinter dem Portal-Login liegt und
// unabhängig vom React-Build aktualisiert werden kann (Datei austauschen, fertig).
function GefaessKalkulator() {
    return (
        <div className="h-full w-full flex flex-col -m-4 md:-m-8">
            <iframe
                title="GefäßKalkulator 2026"
                src="/gefaesskalkulator/index.html"
                className="flex-1 w-full border-0 bg-white"
            />
        </div>
    );
}

export default GefaessKalkulator;
